<template>
  <div id="app" class="app">

    <sui-segment basic id="loadingSegment">
      
      <loader/>

      <router-view />

    </sui-segment>
    
  </div>
</template>

<script>
import Loader from "../components/partiels/loader";
import axios from "axios";
export default {
  components:{
    Loader
  },
  name:'app'
  
}
</script>

<style lang="scss">
@import "../sass/main.scss";

body {
  height: 100%;

  #app {
    height: 100%;
  }
}
#loadingSegment{
  padding: inherit;
}
</style>
